import { render, staticRenderFns } from "./DashboardGraph.vue?vue&type=template&id=64d11e2c&"
import script from "./DashboardGraph.vue?vue&type=script&lang=ts&"
export * from "./DashboardGraph.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports